<template xmlns="http://www.w3.org/1999/html">

  <div style="width: 100%;
    position:fixed;
    background: url(/static/images//huaku/fullbg.png) no-repeat center center;
    background-size: cover;
    background-position: top;
    height: 100%;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;z-index: 0;">
    <img src="/static/images/huaku/logo.png" style="width: 78%;position: absolute;left: 11%;top:10%" />
    <img src="/static/images/huaku/pingzi.png" style="width: 15%;position: absolute;right: 13%;bottom:2%" />

    <!-- 扫码页面开始 -->
    <div
      style="position: absolute;top:32%;display: flex;flex-direction: column;justify-content:center;align-items: center;">
      <img src="/static/images/huaku/fangwei.png" style="width: 75%;" />
      <div
        style="width: 75%;background-color: white;margin-top:10px;padding-top:8px;padding-bottom: 8px;border: 0px;text-align: center;border-radius: 7px;font-size: 14px;">
        瓶身刮开涂层，扫一扫或输入防伪码
      </div>
      <div style="width: 75%;background-color: white;margin-top:10px;padding-top:3px;padding-bottom: 3px;
        border: 0px;text-align: left;border-radius: 7px;font-size: 14px;padding-top:10px;padding-bottom: 10px;padding-left:5%;padding-right: 5%;
        display: flex;flex-direction: column;">
        <span style="color:rgb(141,141,141);">扫一扫查防伪</span>
        <div @click="scanCode"
          style="width: 100%;background-color: rgb(46, 96, 63);margin-top: 10px;color: white;display: flex;align-items: center;justify-content: center;height: 32px;border: 0px;text-align: center;border-radius: 7px;font-size: 14px;">
          <img src="/static/images/huaku/scan.png" style="width: 14px;" />
          &nbsp;&nbsp;点击扫码
        </div>
        <span style="color:rgb(141,141,141);margin-top: 10px;">输入查防伪</span>
        <div class="input-container">
          <input type="text" v-model="antiCode" placeholder="请输入16位防伪码" class="anti-code-input" @input="handleInput" />
          <button class="confirm-button" @click="getAntiInput">确定</button>
        </div>
      </div>
    </div>
    <!-- 扫码页面结束 -->


    <!--查询结果成功页面开始 -->
    <!--查询结果成功页面结束 -->

    <!--查询结果失败页面开始 -->
    <!-- 查询结失败页面结束 -->


  </div>
</template>
<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>

<style scoped>
.input-container {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 25px;
  overflow: hidden;
  width: 100%;
  /* Adjust width as needed */
  margin-top: 10px;
}

.anti-code-input {
  border: none;
  padding: 0px 0px 0px 10px;
  flex: 1;
  font-size: 14px;
}

.confirm-button {
  background-color: #2E603E;
  /* 深绿色背景 */
  color: white;
  border: none;
  padding: 5px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 0 10px 10px 0;
  outline: none;
}

.confirm-button:hover {
  background-color: #24503A;
  /* Slightly darker green on hover */
}
</style>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      antiCode: ""
    }
  },
  methods: {
    handleInput() {
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ');
    },
    scanCode() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : '';
          }
          this.$router.push({ path: '/tianyi', query: { c: scanQRCode } });
        }
      });
    },
    getAntiInput() {
      const code = this.antiCode.replace(/ /g, '');
      if (/^\d+$/.test(code) && code.length === 16) {
        this.$router.push({ path: '/tianyi', query: { c: code } });
      } else {
        alert('请输入正确的16位数字防伪码');
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx8ae619a1dbc50c9e").then(res => {
        console.log(res)
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  created: function () {
    this.getWxJs()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HuaKu/Scan.vue